'use client'

import { Card, CardContent, Chip, Grid, Stack } from '@mui/material'
import moment from 'moment'
import TotalRow from './TotalRow'
import { convertToEnglishWordList, Logger, Section, Typography } from '@wolfdanepug/common-react'

export default function OrderDetail(props: any) {
	Logger.log('[OrderDetail]', props)
	const { order, loading } = props

	return (
		<>
			<Section sx={{ container: { pt: 3 } }}>
				<Grid container spacing={3}>
					<Grid item md={6}>
						<Card sx={{ height: '100%' }} elevation={0}>
							<CardContent>
								<Grid container spacing={2}>
									<Grid item md={8}>
										<Typography variant="h6" loading={loading}>
											Order Date:
										</Typography>
									</Grid>
									<Grid item md={4}>
										<Typography textAlign={'right'} loading={loading}>
											{order?.createdAt ? moment(order.createdAt).format('MMMM Do YYYY') : ''}
										</Typography>
									</Grid>
									<Grid item md={8}>
										<Typography variant="h6" loading={loading}>
											Order ID:
										</Typography>
									</Grid>
									<Grid item md={4}>
										<Typography loading={loading}>
											{order?.id.split('-').pop().toUpperCase() || ''}
										</Typography>
									</Grid>
									<Grid item md={8}>
										<Typography variant="h6" loading={loading}>
											Delivery Date:
										</Typography>
									</Grid>
									<Grid item md={4}>
										<Typography loading={loading}>TBD</Typography>
									</Grid>
									<Grid item md={8}>
										<Typography variant="h6" loading={loading}>
											Status:
										</Typography>
									</Grid>
									<Grid item md={4}>
										<Chip
											label="Progress"
											sx={{
												borderRadius: 2,
												backgroundColor: 'palette.warning.light',
												color: 'palette.warning.main'
											}}
										/>
									</Grid>
									<Grid item md={8}>
										<Typography variant="h6" loading={loading}>
											Payment Status:
										</Typography>
									</Grid>
									<Grid item md={4}>
										<Chip
											label="Paid"
											sx={{
												borderRadius: 2,
												backgroundColor: 'palette.success.light',
												color: 'palette.success.main'
											}}
										/>
									</Grid>
								</Grid>
							</CardContent>
						</Card>
					</Grid>
					<Grid item md={6}>
						<Card sx={{ height: '100%' }} elevation={0}>
							<CardContent>
								<Grid container spacing={2}>
									<Grid item md={2}>
										<Typography variant="h6" loading={loading}>
											Name:
										</Typography>
									</Grid>
									<Grid item md={10}>
										<Typography textAlign={'right'} loading={loading}>
											{order?.billingContact?.name}
										</Typography>
									</Grid>
									<Grid item md={2}>
										<Typography variant="h6" loading={loading}>
											Email:
										</Typography>
									</Grid>
									<Grid item md={10}>
										<Typography textAlign={'right'} loading={loading}>
											{order?.billingContact?.email}
										</Typography>
									</Grid>
									<Grid item md={2}>
										<Typography variant="h6" loading={loading}>
											Phone:
										</Typography>
									</Grid>
									<Grid item md={10}>
										<Typography textAlign={'right'} loading={loading}>
											{order?.billingContact?.phone}
										</Typography>
									</Grid>
									<Grid item md={2}>
										<Typography variant="h6" loading={loading}>
											Address:
										</Typography>
									</Grid>
									<Grid item md={10}>
										<Typography textAlign={'right'} loading={loading}>
											{order?.shippingAddress?.streetAddress} <br />
											{order?.shippingAddress?.city}, {order?.shippingAddress?.state}{' '}
											{order?.shippingAddress?.postalCode}
										</Typography>
									</Grid>
								</Grid>
							</CardContent>
						</Card>
					</Grid>
					<Grid item md={12}>
						<Stack spacing={2}>
							{order?.items.length > 0 &&
								order.items.map((item: any, index: number) => (
									<Card key={item.id} elevation={0}>
										<CardContent>
											<Grid container spacing={2}>
												<Grid item md={1}>
													<Typography loading={loading}>{index + 1}</Typography>
												</Grid>
												<Grid item md={8}>
													<Typography
														variant="h6"
														loading={loading}
													>{`${item.meta.name} ${item.meta.weight}oz. ${
														item.meta.interval / 7
													} week plan`}</Typography>

													<Typography variant="caption" loading={loading}>
														{convertToEnglishWordList(
															item.meta.products.map((product: any) => product.name)
														)}
													</Typography>
												</Grid>
												<Grid item md={1}>
													<Typography loading={loading}>
														$ {(item.price / 100).toFixed(2)}
													</Typography>
												</Grid>
												<Grid item md={2}>
													<Typography loading={loading}>
														{moment(item.createdAt).format('MMMM Do YYYY')}
													</Typography>
												</Grid>
											</Grid>
										</CardContent>
									</Card>
								))}
						</Stack>
					</Grid>
					<TotalRow label="Subtotal" value={(order?.subtotal / 100).toFixed(2)} />
					<TotalRow label="Discount" value={(order?.discountAmount / 100 || 0).toFixed(2)} />
					<TotalRow label="Tax" value={(order?.tax || 0 / 100).toFixed(2)} />
					<TotalRow label="Shipping" value="0.00" />
					<TotalRow label="Total" value={(order?.total / 100).toFixed(2)} />
				</Grid>
			</Section>
		</>
	)
}
